var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V16.8031H0V0Z",
    fill: "#D6D4D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.217438 0.203659H24.8088V5.7369H0.217438V0.203659Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.217468 11.0655H24.8088V16.5981H0.217468V11.0655Z",
    fill: "#FFCF05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.218872 5.73763H24.8102V11.0654H0.218872V5.73763Z",
    fill: "#DB061B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF5);
export default __webpack_public_path__ + "static/media/f5.d29ae563d8d89c707e265a69a43b6a4a.svg";
export { ForwardRef as ReactComponent };